import { type CSSProperties, type FC } from 'react';
import cn from 'classnames';

import css from './styles.module.scss';

interface ScaleProps {
  className?: string;
  height: number;
  percentage: number;
  scaleClassName?: string;
  additionalTrack?: {
    percentage: number;
    className?: string;
    style?: CSSProperties;
  };
}

const Scale: FC<ScaleProps> = ({
  height,
  percentage,
  className,
  additionalTrack,
  scaleClassName,
}) => {
  return (
    <div style={{ height }} className={cn(css.scale, className)}>
      <div
        style={{ width: percentage + '%' }}
        className={cn(css.load, scaleClassName)}
      ></div>
      {additionalTrack && (
        <div
          style={{
            ...additionalTrack.style,
            width: additionalTrack.percentage + '%',
          }}
          className={cn(
            'h-full absolute left-0 top-0 z-[1]',
            'transition-all duration-1000 ease-out',
            additionalTrack.className,
          )}
        ></div>
      )}
    </div>
  );
};

export { Scale };
